import { VNode, h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
// @ts-ignore
import { BNotification } from 'buefy/dist/esm/notification';
// @ts-ignore
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { updateMobileAppDownloaded } from '@/services/api/auth';
import { user, fetchUser } from '@/ui/auth/auth';
import { useTask } from '@/ui/concerns';
import { appStoreBadge, googlePlayStoreBadge } from '@/ui/components/onboarding/StoreImageLink';

export const DownloadApp = defineComponent({
  name: 'DownloadApp',

  setup() {
    const appDownloaded = useTask(
      () => updateMobileAppDownloaded(),
      async () => {
        await fetchUser()();
      },
    );

    return function render(): VNode {
      return h(BNotification, {
        class: 'download-app',
        props: {
          ariaCloseLabel: 'Close',
          active: !user.value.appDownloaded,
        },
        on: {
          close: appDownloaded.run,
        },
      }, [
        h('div', { class: 'download-app__overlay' }, [
          h('div', { class: 'download-app__text' }, [
            h('p', t('common.download-app')),
            h('p', t('common.scan-qr')),
          ]),
          h('div', {
            class: 'download-app__qr',
          }, [
            //Type 'QrCodeConstructor' is not assignable to type 'VueConstructor<Vue>'.
            //legacy, not compatible with Vue typings
            //@ts-ignore
            h(VueQrcode, {
              props: {
                value: process.env.VUE_APP_REDIRECT_TO_APP_URL,
                options: {
                  width: 100,
                  margin: 0,
                },
              },
            }),
          ]),
          h('div', { class: 'download-app__stores' }, [
            appStoreBadge(),
            googlePlayStoreBadge(),
          ]),
        ]),
      ]);
    };
  },
});

export function downloadApp() {
  return h(DownloadApp);
}
